var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"items":_vm.languages,"item-text":"name","item-value":"code","label":_vm.label,"outlined":"","dense":"","loading":_vm.isUpdating,"error":_vm.hasError,"success":_vm.showSuccess},on:{"change":_vm.onInput},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }